/** Human-readable lead workflow status for display (read-only). */
export function formatLeadStatusLabel(status?: string | null): string {
  const raw = status?.trim()
  if (!raw) {
    return "—"
  }

  switch (raw) {
    case "new":
      return "New"
    case "assigned":
      return "Assigned"
    case "referred":
      return "Referred"
    case "archived":
      return "Archived"
    default:
      break
  }

  if (raw.startsWith("assigned_to_")) {
    const name = raw.slice("assigned_to_".length)
    if (!name) {
      return "Assigned"
    }
    return `Assigned to ${name.charAt(0).toUpperCase()}${name.slice(1)}`
  }

  return raw.replace(/_/g, " ")
}
